import React from 'react';

import { addDataLayerEvent } from "../../../../utils/data.layer.utils/data.layer.util";

const LinkButton = ({ button, trackingVals }) => {
	return (
		<a
			title={button.buttonLink.text}
			href={button.buttonLink.url}
			className={`waves-effect waves-light btn-large bb${button.colour}`}
			target={button.buttonLink.target}
			onClick={(e) => {					
				addDataLayerEvent('BannerEventLinkButton', trackingVals);
			}}
		>
			{button.buttonLink.text}
		</a>
	)
};

export default LinkButton;